import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/17_card_back_roses/17_card_back_roses"
 * Contains 1 texture(s)
 */
export class CardsBacks17CardBackRosesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/17_card_back_roses/17_card_back_roses';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '17_roses.png'
    ] as const;
}
